module.exports = __webpack_public_path__ + "assets/img/main_cricket_bg_mob.jpg?15be451a842ecc2d5fbf96e4b455864f";